import pptxgen from 'pptxgenjs'

import { percentageToInches, getCoordinates } from '../helpers'

// 1. Create a Presentation
let pptx = new pptxgen()

/**
 *
 * Constrains:
 * - It doesn't render any style or css, only svg attributes:
 *    - Color has to be set as `fill="#333333"`, using an attribute and hex value
 *        - it also accepts `transparent`, but only that
 *    - Strokes have to be set as `stroke="#ebebeb"` and `strokeWidth={2}`
 * - Rect radius will be used only to set a predefined radius
 * - Slide background and useRects are not rendered
 *
 *  */
function renderRect({ x, y, height, width, parent, svgNode, slide }) {
  const { properties } = svgNode
  if (properties.class === 'ai-useRect' || properties.class === 'ai-slide-background') return

  const rectStyle = {}
  const typeOfRect = properties.rx || properties.ry ? 'roundRect' : 'rect'

  if (properties.fill) {
    if (properties.fill === 'transparent') {
      rectStyle.fill = { color: 'ff0000', transparency: 100 }
    } else {
      rectStyle.fill = properties.fill.substring(1)
    }
  }

  if (properties.stroke) {
    rectStyle.line = {
      color: properties.stroke.substring(1),
      width: (properties['stroke-width'] ?? 2) / 2,
    }
  }

  if (typeOfRect === 'roundRect') {
    rectStyle.rectRadius = 0.08
  }

  const coordinates = getCoordinates({ x, y }, parent)
  const position = {
    x: coordinates.x,
    y: coordinates.y,
    h: percentageToInches(height / 1080, 'y'),
    w: percentageToInches(width / 1920, 'x'),
  }

  slide.addShape(pptx.ShapeType[typeOfRect], { ...rectStyle, ...position })
}

export default renderRect
